export function getColorContrast(color: number[]) {
  const luminance =
    (0.2126 * color[0]) / 255 +
    (0.7152 * color[1]) / 255 +
    (0.0722 * color[2]) / 255;

  return { colorContrast: luminance < 0.7 ? 'white' : 'black', luminance };
}
